
import { Done as DoneIcon } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import React from "react";

interface ActionPanelProps {
  onFinishClick: () => void;
}

const ActionPanel: React.FC<ActionPanelProps> = ({
  onFinishClick,
}) => {
  return (
    <Box sx={{ position: "sticky", top: 24 }}>
      <Card elevation={0} sx={{ border: "1px solid", borderColor: "grey.200" }}>
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Alternativ
          </Typography>
          <Button
            startIcon={<DoneIcon />}
            color="success"
            variant="contained"
            fullWidth
            size="large"
            onClick={onFinishClick}
            sx={{
              mb: 2,
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
            }}
          >
            Slutför aktivitet
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ActionPanel;
